import { useCallback } from "react";

import toast from "react-hot-toast";

import { CheckIcon, Trash2Icon } from "lucide-react";

import { styled } from "simplydo/react/styled";
import { Button } from "simplydo/react/ui/button";
import { Icon } from "simplydo/react/ui/icon";

import api from "api";

import type { NotificationContentProps } from "../../types";

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

const JoinRequestedActions = ({
  events = [],
  invitations = [],
  onAccept,
  onReject,
}: NotificationContentProps) => {
  const invitationId = events[0]?.invitation;
  const invitationExists = invitationId
    ? invitations.find((i) => i._id === invitationId && !i.acceptedAt)
    : undefined;

  const acceptInvite = useCallback(() => {
    if (!invitationId) return;
    api.invitations.accept(
      invitationId,
      () => {
        onAccept?.(invitationId);
        toast.success("Request accepted");
      },
      (err) => {
        toast.error(err.message);
      },
    );
  }, [invitationId, onAccept]);

  const rejectInvite = useCallback(() => {
    if (!invitationId) return;
    api.invitations.reject(
      invitationId,
      () => {
        onReject?.(invitationId);
        toast.success("Request rejected");
      },
      (err) => {
        toast.error(err.message);
      },
    );
  }, [invitationId, onReject]);

  if (!invitationExists) return null;
  return (
    <ButtonContainer>
      <Button
        color="green"
        size="small"
        onClick={acceptInvite}
        style={{ marginBottom: 5 }}
        variant="outline"
      >
        <Icon icon={CheckIcon} />
      </Button>
      <Button size="small" onClick={rejectInvite} variant="outline">
        <Icon icon={Trash2Icon} />
      </Button>
    </ButtonContainer>
  );
};

export default JoinRequestedActions;
